import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { Phone, Building2, Globe2 } from 'lucide-react';
export const Contact = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].contact;
  return <FadeInSection id="contact" className="w-full bg-white py-24 lg:py-32" data-id="element-17" data-mp="2w8ihp95qewsa">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-18" data-mp="3sy9an3ydkbvz">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-19" data-mp="3swyade451m9m">
          <span className="eyebrow mb-4" data-id="element-20" data-mp="3oxfmc9h0sv2k">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-[#1a1a1a] mb-8" data-id="element-21" data-mp="3k561h7uril75">
            {t.headline}
          </h2>

          <div className="w-[60px] h-px bg-[#c9a96e]" data-id="element-22" data-mp="3f5te8lzzbc41" />
        </div>

        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24" data-id="element-23" data-mp="ggkrnhadmgzk">
          {/* Left: Contact Info & Map */}
          <div className="w-full lg:w-1/2 flex flex-col space-y-10" data-id="element-24" data-mp="bouez4nyvh4z">
            <div className="space-y-8" data-id="element-25" data-mp="3jv2v8xvsb81v">
              <div className="flex items-start space-x-6" data-id="element-26" data-mp="3jw4kc69mxv2l">
                <Phone className="text-[#c9a96e] mt-1" size={24} strokeWidth={1.5} data-id="element-27" data-mp="3ov7bqnwp02s3" />
                <div data-id="element-28" data-mp="3b16n4mzgfw5g">
                  <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-1" data-id="element-29" data-mp="3f4utx3g9inpn">
                    Phone
                  </h4>
                  <a href="tel:6513872889" className="font-serif-display text-2xl text-[#1a1a1a] hover:text-[#c9a96e] transition-colors" data-id="element-30" data-mp="314bmnyjmfloj">
                    651.387.2889
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-6" data-id="element-31" data-mp="2w6rzg94y3ykg">
                <Building2 className="text-[#c9a96e] mt-1" size={24} strokeWidth={1.5} data-id="element-32" data-mp="qdbjuxo4uq46" />
                <div data-id="element-33" data-mp="udue0ydi089j">
                  <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-1" data-id="element-34" data-mp="ucawz5k0pt6p">
                    Brokerage
                  </h4>
                  <p className="font-serif-display text-2xl text-[#1a1a1a]" data-id="element-35" data-mp="1ybpqqvq193r8">
                    Coldwell Banker Realty Minnesota
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6" data-id="element-36" data-mp="1pcugn8jvb9in">
                <Globe2 className="text-[#c9a96e] mt-1" size={24} strokeWidth={1.5} data-id="element-37" data-mp="2m1tssynkovg4" />
                <div data-id="element-38" data-mp="2i104i467xemp">
                  <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-1" data-id="element-39" data-mp="2i2ueinfybmc0">
                    Languages
                  </h4>
                  <p className="font-serif-display text-2xl text-[#1a1a1a]" data-id="element-40" data-mp="289lw16wah4hf">
                    English / Español
                  </p>
                </div>
              </div>
            </div>

            {/* Office location */}
            <div className="w-full h-[300px] rounded-lg overflow-hidden bg-[#f8f4ef] relative flex flex-col items-center justify-center gap-4 border border-[#c9a96e]/20" data-id="element-41" data-mp="30x9fgiltpp2h">
              <div className="absolute inset-0 opacity-10" style={{
              backgroundImage: 'radial-gradient(circle at 50% 50%, #c9a96e 1px, transparent 1px)',
              backgroundSize: '24px 24px'
            }} data-id="element-42" data-mp="3dad6zauaduoi" />
              <div className="relative z-10 flex flex-col items-center gap-3 px-6 text-center" data-id="element-43" data-mp="3r8tnfthyazju">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#c9a96e]/10" data-id="element-44" data-mp="1qt4t6tgd5e">
                  <Building2 className="text-[#c9a96e]" size={22} data-id="element-45" data-mp="4ua8nvp2dicu" />
                </div>
                <p className="font-serif-display text-lg text-[#1a1a1a]" data-id="element-46" data-mp="9rjxb94mppzm">
                  3033 Excelsior Blvd, Suite 100
                </p>
                <p className="text-sm uppercase tracking-widest text-[#1a1a1a]/50" data-id="element-47" data-mp="itjd5y3wqo0z">
                  Minneapolis, MN 55416
                </p>
                <a href="https://maps.google.com/?q=3033+Excelsior+Blvd+Suite+100+Minneapolis+MN+55416" target="_blank" rel="noopener noreferrer" className="mt-2 border border-[⌕c9a96e⌕] px-6 py-2 text-xs uppercase tracking-widest text-[⌕c9a96e⌕] transition-all duration-300 hover:bg-[⌕c9a96e⌕] hover:text-white" data-id="element-48" data-mp="55rekab64pxo">
                  View on Google Maps
                </a>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="w-full lg:w-1/2" data-id="element-49" data-mp="3edtzy1p0fs0z">
            <form className="flex flex-col space-y-8" onSubmit={e => e.preventDefault()} data-id="element-50" data-mp="3sbseb73bzogh">
              <div className="flex flex-col" data-id="element-51" data-mp="3nb4dxut7pv9l">
                <input type="text" placeholder={t.form.name} className="w-full bg-transparent border-b border-[⌕1a1a1a⌕]/20 py-4 text-[⌕1a1a1a⌕] placeholder:text-[⌕1a1a1a⌕]/40 focus:outline-none focus:border-[⌕c9a96e⌕] transition-colors rounded-none" data-id="element-52" data-mp="17l1gm3fdebvi" />
              </div>

              <div className="flex flex-col" data-id="element-53" data-mp="2pkhjfwbt006l">
                <input type="email" placeholder={t.form.email} className="w-full bg-transparent border-b border-[⌕1a1a1a⌕]/20 py-4 text-[⌕1a1a1a⌕] placeholder:text-[⌕1a1a1a⌕]/40 focus:outline-none focus:border-[⌕c9a96e⌕] transition-colors rounded-none" data-id="element-54" data-mp="2bjetv9llo7qx" />
              </div>

              <div className="flex flex-col" data-id="element-55" data-mp="3884e36kp9cg2">
                <input type="tel" placeholder={t.form.phone} className="w-full bg-transparent border-b border-[⌕1a1a1a⌕]/20 py-4 text-[⌕1a1a1a⌕] placeholder:text-[⌕1a1a1a⌕]/40 focus:outline-none focus:border-[⌕c9a96e⌕] transition-colors rounded-none" data-id="element-56" data-mp="2ui0u6m9aluts" />
              </div>

              <div className="flex flex-col relative" data-id="element-57" data-mp="3rygc9a3sjm5x">
                <select className="w-full bg-transparent border-b border-[⌕1a1a1a⌕]/20 py-4 text-[⌕1a1a1a⌕] focus:outline-none focus:border-[⌕c9a96e⌕] transition-colors appearance-none rounded-none cursor-pointer" defaultValue="" data-id="element-58" data-mp="5nzh1qdgiwpi">
                  <option value="" disabled className="text-[#1a1a1a]/40" data-id="element-59" data-mp="3rx0sa5r61jsh">
                    {t.form.interest}
                  </option>
                  {t.form.options.map((opt, i) => <option key={i} value={opt} data-id="element-60" data-mp="3iwm5f1yjzwmv" data-mpi={i}>
                      {opt}
                    </option>)}
                </select>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none" data-id="element-61" data-mp="393wxui64j2wt">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-62" data-mp="346ekmfl2q1j0">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-63" data-mp="2v5gmgdxbgo8c" />
                  </svg>
                </div>
              </div>

              <div className="flex flex-col" data-id="element-64" data-mp="1jlrn0jt14j90">
                <textarea placeholder={t.form.message} rows={4} className="w-full bg-transparent border-b border-[⌕1a1a1a⌕]/20 py-4 text-[⌕1a1a1a⌕] placeholder:text-[⌕1a1a1a⌕]/40 focus:outline-none focus:border-[⌕c9a96e⌕] transition-colors resize-none rounded-none" data-id="element-65" data-mp="1olmbkgpc0wqw" />
              </div>

              <button type="submit" className="w-full py-5 bg-[#c9a96e] text-[#1a1a1a] uppercase tracking-widest text-sm font-medium hover:bg-[#b5955a] transition-colors duration-300 mt-4" data-id="element-66" data-mp="15nt89dasqksz">
                {t.form.submit}
              </button>
            </form>
          </div>
        </div>
      </div>
    </FadeInSection>;
};